import React, { useEffect, useState } from "react";
import SearchInput from "../../generic/elements/search/SearchInput";
import { notification, Row, Table } from "antd";
import PrimaryButton from "../../../components/generic/buttons/PrimaryButton";
import AddEditWorkforceModal, {
  workforceDataUpdateResponse,
} from "../workforce/AddEditWorkforceModal";
import { useRecoilState } from "recoil";
import InvitationListTableColumns from "../manageinvitations/columns/InvitationListTableColumns";
import { executeIntent } from "../../utils/IntentExecutor";
import IntentType from "../../../intentexecutor/utils/IntentType";
import { Grid } from "@mui/material";
import { Item } from "./styledComponent";
import { inviteUsersDataState } from "../../../components/recoil/inviteUsersRecoil";
import { useReadMemory } from "../../generic/hooks/useReadMemory";
import MemoryType from "../../../service/memory/enum/MemoryType";
import { useObservable } from "../../generic/hooks/useObservable";
import ErrorNotificationComponent from "../../../components/generic/error/ErrorNotificationComponent";

const InviteUsers = ({ organizationIdentifier }) => {
  const userJson = useReadMemory(MemoryType.USER);
  const [openAddWorkforceModal, setOpenAddWorkforceModal] = useState(false);
  const [tableData, setTableData] = useRecoilState(inviteUsersDataState);
  const [searchQuery, setSearchQuery] = useState("");
  const [tableLoading, setTableLoading] = useState(false);
  const [reload, setReload] = useState(false);
  const [loadingRow, setLoadingRow] = useState({});
  useObservable(workforceDataUpdateResponse, setReload);

  const context = {
    organizationIdentifier,
    role: userJson?.jobTitle,
    userIdentifier: userJson?.userIdentifier,
  };

  const handleAddWorkforceClick = () => {
    setOpenAddWorkforceModal(!openAddWorkforceModal);
  };

  const resendInvite = async (item) => {
    const id = item?.userIdentifier || item?.key;
    setLoadingRow((prev) => ({ ...prev, [id]: true }));
    const payload = {
      data: {
        userIdentifier: item?.userIdentifier,
        creatorIdentifier: userJson?.userIdentifier,
      },
    };
    try {
      const response = await executeIntent(
        IntentType.SEND_INVITE_TO_WORKFORCE,
        payload
      );
      if (response?.status) {
        notification.success({
          message: "Invitation Sent Successfully",
          placement: "bottomRight",
        });
      } else {
        notification.error({
          message: "Failed to Send Invitation",
          placement: "bottomRight",
        });
      }
    } catch (err) {
      ErrorNotificationComponent(err);
    } finally {
      setLoadingRow((prev) => ({ ...prev, [id]: false }));
    }
  };

  const { columns } = InvitationListTableColumns({ resendInvite, loadingRow });

  const fetchWorkforceListData = async () => {
    setTableLoading(true);
    const payload = {
      page: 1,
      pageSize: 100,
      organizationIdentifier,
      filters: {
        isActive: true,
      },
    };
    const responseData = await executeIntent(
      IntentType.GET_ALL_WORKFORCE,
      payload,
      context
    );
    if (Array.isArray(responseData?.workforceList)) {
      setTableData(responseData?.workforceList);
    }
    setTableLoading(false);
  };

  const fetchSearchedData = async () => {
    setTableLoading(true);
    const searchPayload = {
      query: searchQuery,
      organizationIdentifier,
    };
    const responseData = await executeIntent(
      IntentType.SEARCH_WORKFORCE,
      searchPayload,
      context
    );
    setTableData(responseData?.workforceList);
    setTableLoading(false);
  };

  useEffect(() => {
    if (searchQuery.length) {
      fetchSearchedData();
    } else if (!searchQuery.length) {
      fetchWorkforceListData();
    }
    if (reload) {
      setReload(false);
    }
  }, [searchQuery, reload]);

  return (
    <>
      <Grid container spacing={2} sx={{ paddingBlock: 2 }}>
        <Grid xs={12} item>
          <Item elevation={0}>
            <h6 className="add-edit-patient-sub-header">Invite Team Members</h6>
          </Item>
        </Grid>
      </Grid>

      <Row className="invitation-search-container invitation-custom-search-component">
        <SearchInput
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          cssClass="invitationSearchField"
          searchPlaceholder={"Search Invited Users..."}
        />
        <div className="invite-buttons">
          <PrimaryButton
            buttonText="Invite Team Members"
            handleOnClick={handleAddWorkforceClick}
          />
        </div>
      </Row>

      <div className="tableContainerStyling care-plan-table">
        <div className="scroll-container" id="scrollableDiv">
          <Table
            className="tableStyling"
            columns={columns}
            dataSource={tableData?.map((item, index) => ({
              ...item,
              key: index,
            }))}
            pagination={false}
            scroll={{ y: 10 * 60 }}
            loading={tableLoading}
          />
        </div>
      </div>

      {openAddWorkforceModal && (
        <AddEditWorkforceModal
          openAddWorkforceModal={openAddWorkforceModal}
          setOpenAddWorkforceModal={setOpenAddWorkforceModal}
          showAdditionalFields={false}
          organizationId={organizationIdentifier}
        />
      )}
    </>
  );
};

export default InviteUsers;
